<template>
    <div class="">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-copy"></i>待办项</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="message" @tab-click="handleClick">
                <el-tab-pane :label="`牌照审核(${licenseTotal})`" name="first">
					<!-- <router-link to="/licensecheckfzorgan"> -->
					<router-link to="/licensecheckfzorgan/first/1">
					    <p class="num_item">
					    	<span>分支机构</span>{{licenseRemindBranchBusinessNum}}
					    </p>
					</router-link>
					<router-link to="/licensecheckxcx/first/1">
					    <p class="num_item">
					    	<span>小程序用户</span>{{licenseRemindCommonNum}}
					    </p>
					</router-link>
					<router-link to="/licensecheckzbperson">
					    <p class="num_item">
					    	<span>总部业务员</span>{{licenseRemindHeadBusinessNum}}
					    </p>
					</router-link>
					<router-link to="/licensecheckjxshop/first/1">
					    <p class="num_item">
					    	<span>厂商业务员</span>{{licenseRemindManufacturerBusinessNum}}
					    </p>
					</router-link>
                   <!-- <el-table :show-header="false" style="width: 100%">
                        <el-table-column>
                           
							分支机构
                        </el-table-column>
                        <el-table-column>
							小程序用户 
						</el-table-column>
                        <el-table-column width="120">
                            <template slot-scope="scope">
                                <el-button size="small" @click="handleRead(scope.$index)">标为已读</el-button>
                            </template>
                        </el-table-column>
                    </el-table> -->
                    <!-- <div class="handle-row">
                        <el-button type="primary">全部标为已读</el-button>
                    </div> -->
                </el-tab-pane>
                <el-tab-pane :label="`操作证审核(${certificateTotal})`" name="second">
                    <template v-if="message === 'second'">
                        <!-- <el-table :data="read" :show-header="false" style="width: 100%">
                            <el-table-column>
                                <template slot-scope="scope">
                                    <span class="message-title">{{scope.row.title}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" width="150"></el-table-column>
                            <el-table-column width="120">
                                <template slot-scope="scope">
                                    <el-button type="danger" @click="handleDel(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="handle-row">
                            <el-button type="danger">删除全部</el-button>
                        </div> -->
						<router-link to="/certificatecheckfzorgan/checkfirst/1">
						    <p class="num_item">
						    	<span>分支机构</span> {{certificateRemindBranchBusinessNum}}
						    </p>
						</router-link>
						<router-link to="/certificatecheckxcx/checkfirst/1">
						    <p class="num_item">
						    	<span>小程序用户</span> {{certificateRemindCommonNum}} 
						    </p>
						</router-link>
						<router-link to="/certificatecheckzbperson/checkfirst/1">
						    <p class="num_item">
						    	<span>总部业务员</span>{{certificateRemindHeadBusinessNum}}
						    </p>
						</router-link>
						<router-link to="/certificatecheckjxshop/checkfirst/1">
						    <p class="num_item">
						    	<span>厂商业务员</span>{{certificateRemindManufacturerBusinessNum}}
						    </p>
						</router-link>
						
                    </template>
                </el-tab-pane>
				<el-tab-pane v-if="role == '1'" label="统计图表" name="three">
				</el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
	import { listTaskRemindNum } from '@/api/index';// 导入我们的api接口
    export default {
        name: 'remandmessage',
        data() {
            return {
                message: 'first',
				licenseRemindBranchBusinessNum:'',
				licenseRemindCommonNum:'',
				licenseRemindHeadBusinessNum:'',
				licenseRemindManufacturerBusinessNum:'',
				licenseTotal:'',
				
				certificateRemindBranchBusinessNum:'',
				certificateRemindCommonNum:'',
				certificateRemindHeadBusinessNum:'',
				certificateRemindManufacturerBusinessNum:'',
				certificateTotal:'',
				role: '',
                unread: [{
                    date: '2018-04-19 20:00:00',
                    title: '【系统通知】该系统将于今晚凌晨2点到5点进行升级维护',
                },{
                    date: '2018-04-19 21:00:00',
                    title: '今晚12点整发大红包，先到先得',
                }],
                read: [{
                    date: '2018-04-19 20:00:00',
                    title: '【系统通知】该系统将于今晚凌晨2点到5点进行升级维护'
                }],
                recycle: [{
                    date: '2018-04-19 20:00:00',
                    title: '【系统通知】该系统将于今晚凌晨2点到5点进行升级维护'
                }]
            }
        },
		created() {
			listTaskRemindNum({}).then(res => {
				   this.totalNum = res.data.totalNum;
				   this.licenseRemindBranchBusinessNum = res.data.licenseRemindBranchBusinessNum;
				   this.licenseRemindCommonNum = res.data.licenseRemindCommonNum;
				   this.licenseRemindHeadBusinessNum = res.data.licenseRemindHeadBusinessNum;
				   this.licenseRemindManufacturerBusinessNum = res.data.licenseRemindManufacturerBusinessNum;
				   this.licenseTotal = res.data.licenseRemindBranchBusinessNum +
										res.data.licenseRemindCommonNum +
										res.data.licenseRemindHeadBusinessNum +
										res.data.licenseRemindManufacturerBusinessNum;
										
				   
				   this.certificateRemindBranchBusinessNum = res.data.certificateRemindBranchBusinessNum;
					this.certificateRemindCommonNum = res.data.certificateRemindCommonNum;
					this.certificateRemindHeadBusinessNum = res.data.certificateRemindHeadBusinessNum;
					this.certificateRemindManufacturerBusinessNum = res.data.certificateRemindManufacturerBusinessNum;
					this.certificateTotal = res.data.certificateRemindBranchBusinessNum +
											res.data.certificateRemindCommonNum +
											res.data.certificateRemindHeadBusinessNum +
											res.data.certificateRemindManufacturerBusinessNum;
			});
			this.role = localStorage.getItem('role');
		},
        methods: {
            handleRead(index) {
                const item = this.unread.splice(index, 1);
                console.log(item);
                this.read = item.concat(this.read);
            },
            handleDel(index) {
                const item = this.read.splice(index, 1);
                this.recycle = item.concat(this.recycle);
            },
            handleRestore(index) {
                const item = this.recycle.splice(index, 1);
                this.read = item.concat(this.read);
            },
			handleClick(){
				console.log(this.message)
				if(this.message == 'three'){
					this.$router.push('/indexEcharts');
				}
			}
        },
        computed: {
            unreadNum(){
                return this.unread.length;
            }
        }
    }

</script>

<style>
.message-title{
    cursor: pointer;
}
.handle-row{
    margin-top: 30px;
}
.num_item{
	border-bottom: 1px solid #ddd;
	font-size: 14px;
	color: #666;
	letter-spacing: 1px;
	padding: 10px 0;
}
.num_item span{
	display: inline-block;
	width: 150px;
}
</style>

